/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-03-31 10:29:01
 * @LastEditTime : 2025-03-31 13:53:20
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\common\system.js
 */
/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2025-03-14 11:47:25
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-03-14 15:06:36
 * @Description: 系统配置说明文件
 * @FilePath: /icps_pcweb/src/common/system.js
 */
const SystemId = 'bdd082f8565d432c9c1e740f5ea76216'

const SystemCompany = '四川华西绿舍建材有限公司'

const SystemName = '华西绿舍预拌混凝土'

const SystemDet = '智造系统（ICPS）'

const SystemMark = '*本平台为互联网非涉密平台，严禁处理、传输国家秘密、工作秘密。'

const SystemICP = '蜀ICP备12012544号-1'

const SystemCopyright = 'Copyright © 2025 华西绿舍建材有限公司'

const SystemFA = '51019002006352号'

export {
    SystemCompany, SystemCopyright, SystemDet, SystemFA, SystemICP, SystemMark, SystemName, SystemId
}
